export const pricing = {
  pageHeader: {
    title: 'Your fee',
  },
  pricingFeatures: {
    group1: {
      feature1: {
        label: 'Create invoices, quotations, credit notes …',
      },
      feature2: {
        label: 'Copyright 100% correct',
      },
      feature3: {
        label: 'Clear dashboard',
      },
      feature4: {
        label: 'A Community you can count on',
      },
      title: 'Handy invoicing platform',
    },
    group2: {
      feature1: {
        label: 'Paying withholding tax',
      },
      feature2: {
        label: 'Drawing up tax forms',
      },
      feature3: {
        label: 'Drafting contracts',
      },
      feature4: {
        label: 'Payment follow-up',
      },
      title: 'We handle the admin',
    },
    group3: {
      feature1: {
        label: 'No chatbots, but people',
      },
      feature2: {
        label: 'Double-check of your invoices',
      },
      feature3: {
        label: 'Technical support',
      },
      feature4: {
        label: 'Advice in plain language',
      },
      title: 'Personal help',
    },
    title: 'What you get from us',
  },
  pricingInfo: {
    commission: {
      details: {
        button: 'Details',
        commissionWithDiscount: 'New fee',
        commissionWithoutDiscount: 'Standard fee',
        freeTrial_one: '{{count}} day free',
        freeTrial_other: '{{count}} days free',
        referralDiscount: 'Referral {{inviteeName}}',
      },
      deviations: {
        adminOverride: {
          explanation: 'Your fee differs from the standard rate.',
          label: 'Adjusted fee',
        },
        earlyAdopter: {
          label: 'Early adopter',
        },
        loyalUser: {
          label: 'Loyal Shelterer',
          tooltip:
            'You’ve been with us for a while, so we’d like to thank you with a lower fee. New Shelterers who have joined since 2025 pay a fixed fee of 8%.',
        },
        premiumForFree: {
          label_one: '{{count}} more day free',
          label_other: '{{count}} more days free',
          tooltip: 'Valid up to and including {{expirationDate}}',
        },
        referralDiscount: {
          label: 'Referral discount ({{amount}})',
        },
        yearlyCopyrightLimitExceeded: {
          explanation:
            'You’ve exceeded your copyright limit for this year. All your services now count as professional income, so you can invoice for free until the end of the year.',
          label: 'Copyright limit reached',
        },
      },
      explanation: {
        subTitle: 'Only a fee when you invoice.',
        text: 'This is what Creative Shelter deducts from the total amount of your invoice (excl. VAT), per creative service. You only pay when you invoice. No invoice? No costs.',
        title: 'No subscription.',
      },
      title: 'Fee per invoice',
    },
  },
  pricingStats: {
    currentYear: {
      text: 'Benefit thanks to Creative Shelter',
      title: 'Benefit in {{year}}',
    },
    error: {
      title: 'No data found',
    },
    previousYear: {
      text: 'Total benefit thanks to Creative Shelter',
      title: 'Total benefit in {{year}}',
    },
  },
};
